import React from 'react'

const ProductCard = ({ data, type }) => {
    return (
        <div className="col-md-6 col-lg-4 my-3  wow animate__fadeIn" data-wow-delay="0.1s" data-wow-duration="1s" onClick={e => window.open(`/${type}/${data?.id}`)}>
            <div className="proCardBord">
                <img src={data?.image} alt="Lemon Powder Product Image" draggable="false" className="img-fluid" />
                <h4 className="Viga proCardHead mb-1">{data?.title}</h4>
                <div className="proCardDec">
                    {data?.about.substring(0, 200)}...
                </div>
                <div className="f-18 fw-semi cl-51 mt-4 mb-2">For More Information :</div>
                <div className="d-flex"><a href="#" className="proCardBtn detail-card-btn11 w-100 mb-3" data-toggle="modal" data-target="#exampleModal-1">Inquiry via Gmail</a></div>
                <div className="d-flex"><a href="#" className="proCardBtn detail-card-btn22 w-100" data-toggle="modal" data-target="#exampleWhatsappModal-1">Inquiry via Whatsapp</a></div>
            </div>
        </div>
    )
}

export default ProductCard